jQuery(document).ready(function($){
  // Initialize the hero slider (main product images)
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    // fade: true,
    asNavFor: '.slider-nav' // Link with thumbnail slider
});

// Initialize the thumbnail slider
$('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for', // Link with hero slider
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: false,
});



  
  });



  function showTabContent(event, tabId) {
    // Prevent default link behavior
    event.preventDefault();

    // Get all tab links and tab content
    var tabs = document.querySelectorAll('.nav-link');
    var contents = document.querySelectorAll('.tab-content');

    // Remove active class from all tabs and hide all tab content
    tabs.forEach(function (tab) {
        tab.classList.remove('active');
    });
    contents.forEach(function (content) {
        content.classList.remove('active');
    });

    // Set the clicked tab as active and show its content
    event.target.classList.add('active');
    document.getElementById(tabId).classList.add('active');
}




function toggleAccordion(event, contentId) {
  // Prevent default action
  event.preventDefault();

  // Get the clicked accordion item and toggle its 'open' class
  const item = event.target.closest('.accordion-item');
  item.classList.toggle('open');

  // Toggle the display of the content section
  const content = document.getElementById(contentId);
  if (content.style.display === "block") {
      content.style.display = "none";
  } else {
      content.style.display = "block";
  }
}

// setTimeout(() => {
//   $('.relatedProduct').slick({
//     slidesToShow: 4,
//     arrows: true,
//     dots:false,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     slidesToScroll: 1,
//     infinite: true,
//     responsive: [
//         {
//           breakpoint: 991,
//           settings: {
//             slidesToShow: 3,
//           }
//         },
//         {
//           breakpoint: 500,
//           settings: "unslick"
//         }
//       ]
//   });
// }, 3000);

  document.addEventListener('DOMContentLoaded', function() {
    const decrementButton = document.querySelector('.decrement-btn');
    const incrementButton = document.querySelector('.increment-btn');
    const quantityInput = document.querySelector('.quantity-input');

    // Decrement button functionality
    decrementButton.addEventListener('click', function() {
      let currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });

    // Increment button functionality
    incrementButton.addEventListener('click', function() {
      let currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
    });

    // Prevent user from entering negative or invalid values
    quantityInput.addEventListener('input', function() {
      let currentValue = parseInt(quantityInput.value);
      if (isNaN(currentValue) || currentValue < 1) {
        quantityInput.value = 1; // Ensure min value is 1
      }
    });
  });

document.querySelector('form').addEventListener('submit', function(event) {
  event.preventDefault();

  var formData = {
    'id': document.querySelector('input[name="id"]').value,
    'quantity': document.querySelector('.quantity-input').value
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
     openCartDrawer(); 
    console.log('Product added to cart:', data);
    // Optionally update the cart UI here
  })
  .catch((error) => {
    console.error('Error:', error);
  });
});



